import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthCoreConfig, AuthService } from '@ortho-next/auth-core';
import { AppConfig, isGuid } from './core';


/**
* Authentication configuration for application.
*/
export function getAuthConfig(config: AppConfig): AuthCoreConfig {
	return {
		allowedUrls: [
			config.domainUserAPI,
			config.domainPatientAPI,
			config.domainImageAPI,
			config.domainRayAPI,
			config.domainIntegrationAPI
		],
		appSSOutUriApi: config.appSSOutUriApi,
		applicationScope: config.b2cApplicationScope,
		clientId: config.b2cClientId,
		idleTimeToEndSession: config.idleTimeToEndSession,
		tenantName: config.b2cTenantName,
		resetPasswordPolicyId: config.b2cResetPasswordPolicyId,
		signInPolicyId: config.b2cSignInPolicyId,
		showDebugInformation: config.envName !== 'production'
	};
}

export async function initAuth(authSrv: AuthService, config: AppConfig, modalSrv: NgbModal): Promise<void> {
	return authSrv.runInitialLoginSequence().then(() => {
		const urlParams = new URLSearchParams(globalThis.location.search);
		const caseGuid = urlParams.get('caseGuid');
		const hasOpenModals = modalSrv.hasOpenModals(); // prevent redirect for app version guard
		if (!hasOpenModals && !isGuid(caseGuid)) {
			globalThis.location.href = config.patplanSite;
		}
	});
}

export const DEFAULT_APP_VERSION = '2.1.0';